var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWazirxIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 51,
    viewBox: "0 0 228 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5709 18.0938H80.8796L84.8906 33.7917L89.3318 18.0938H96.0647L100.506 33.7917L104.517 18.0938H112.826L104.517 43.4833H97.2107L92.5548 26.8982L88.114 43.4152H80.6649L72.5709 18.0938Z",
    fill: "#3067F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.939 37.1365C124.221 37.1365 121.206 34.2643 121.206 30.721C121.206 27.1776 124.221 24.3051 127.939 24.3051C131.657 24.3051 134.672 27.1776 134.672 30.721C134.672 34.2643 131.657 37.1365 127.939 37.1365ZM134.672 18.026V20.7621C133.291 18.4597 131.004 17.207 127.366 17.207C119.375 17.207 113.184 23.1064 113.184 30.721C113.184 38.3352 119.088 44.5079 127.079 44.5079C130.916 44.5079 133.271 43.1969 134.672 40.8452V43.4155H142.551V18.026H134.672Z",
    fill: "#3067F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.276 18.0273H166.045V24.0334L155.73 37.6838H166.045V43.4168H146.276V38.2298L157.593 23.7604H146.276V18.0273Z",
    fill: "#3067F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.626 43.4168H177.648V18.0273H169.626V43.4168Z",
    fill: "#3067F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.828 20.6175V18.026H183.379V43.4159H191.401V29.151C191.401 24.4419 197.561 24.8514 197.561 24.8514V17.207C193.669 17.207 191.695 19.2841 190.828 20.6175Z",
    fill: "#3067F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.564 18.0273H208.162L212.459 24.7159L216.757 18.0273H226.355L217.187 29.9033L227.358 43.0073V43.4168H217.76L212.459 35.6363L207.159 43.4168H197.561V43.0073L207.589 29.9033L198.564 18.0273Z",
    fill: "#3067F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.076 12.4323C177.076 10.6229 175.536 9.15625 173.637 9.15625C171.739 9.15625 170.199 10.6229 170.199 12.4323C170.199 14.2417 171.739 15.7083 173.637 15.7083C175.536 15.7083 177.076 14.2417 177.076 12.4323Z",
    fill: "#3067F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39319 50.9994H56.7834V44.8867H2.39319V50.9994Z",
    fill: "#3067F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4162 20.7543L0 11.8789L2.46635 38.3673L13.4162 20.7543Z",
    fill: "#3067F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1454 41.624H56.8384L59.5392 12.5547L19.1454 41.624Z",
    fill: "#3067F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4243 20.2049L12.9135 41.4219H4.78632L19.7819 17.2711L29.3537 1.96094L42.4243 20.2049Z",
    fill: "#3067F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWazirxIcon);
export default __webpack_public_path__ + "static/media/wazirxIcon.119d5349018367ab3a31615128e7055b.svg";
export { ForwardRef as ReactComponent };